"use client";

import { MotionConfig } from "framer-motion";
import type { ReactNode } from "react";

/**
 * Client-side providers for the public site. `reducedMotion="user"` turns
 * off transform and layout animations for people who asked for less motion;
 * the Reveal component handles opacity so content is never left invisible.
 */
export function MarketingProviders({ children }: { children: ReactNode }) {
  return <MotionConfig reducedMotion="user">{children}</MotionConfig>;
}
